module.exports = __webpack_public_path__ + "static/Zitrone-309afb6635be45697e672754fe7d2345.png";